import { create } from "zustand";
import { persist } from "zustand/middleware";

interface PreferencesState {
  selectedPseudoFirm: string | null;
  firmSelectionMade: boolean;
  setSelectedPseudoFirm: (firm: string | null) => void;
  setFirmSelectionMade: (made: boolean) => void;
  clearPreferences: () => void;
}

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set) => ({
      selectedPseudoFirm: null,
      firmSelectionMade: false,
      setSelectedPseudoFirm: (firm) => set({ selectedPseudoFirm: firm }),
      setFirmSelectionMade: (made) => set({ firmSelectionMade: made }),
      clearPreferences: () => set({ selectedPseudoFirm: null, firmSelectionMade: false }),
    }),
    {
      name: "demanda-preferences", // unique identifier for localStorage
    }
  )
);
